import React, { Component } from "react"
import { connect } from "react-redux"
import ReactGA from "react-ga"

import { Product } from "../src/api"
import { BUSINESSID } from "./api/ROOTURL"
import { fetchCategories } from "./redux/actions/productActions"

export default function init(WrappedComponent) {
  class Wrapper extends Component {
    constructor(props) {
      super(props)
    }

    componentDidMount() {
      this.createCategories()

      ReactGA.initialize("G-JEY0F8ZR0V")
      ReactGA.pageview(window.location.pathname + window.location.search)
    }

    createCategories = async () => {
      let roots = []
      let all = {}
      let categoriesData = await Product.productCategories()

      categoriesData.data.map((item) => {
        all[item.productcategoryID] = item
      })

      Object.keys(all).forEach((productId) => {
        let item = all[productId]

        if (item.parent == null) roots.push(item)
        else if (item.parent in all) {
          let parent = all[item.parent]
          if (!("subCategories" in parent)) parent.subCategories = []
          parent.subCategories.push(item)
        }
      })

      this.props.fetchCategories(roots)
    }

    render() {
      return <WrappedComponent {...this.props} />
    }
  }

  const mapStateToProps = (state) => ({
    categories: state.productData.categories,
  })

  const mapDispatchToProps = (dispatch) => ({
    fetchCategories: (data) => {
      dispatch(fetchCategories(data))
    },
  })

  return connect(mapStateToProps, mapDispatchToProps)(Wrapper)
}
